import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { isAppAuthSelector } from 'pricing-pages-ui/selectors/AuthSelectors';
import styled from 'styled-components'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import UIEEConnectedContactSalesButton from 'ui-addon-upgrades/button/UIEEConnectedContactSalesButton';
import { productForSkuIdSelector, upgradeProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { APP, SCREENS, MERCH_CARD } from 'pricing-pages-ui/constants/tracking/Locations';
// Double check IE if you modify / remove this
const CTAContainer = styled.div.withConfig({
  displayName: "FallbackMerchCardCTAsContainer__CTAContainer",
  componentId: "thw7pj-0"
})(["display:flex;flex-direction:column;align-items:stretch;"]);

const FallbackMerchCardCTAsContainer = ({
  skuId
}) => {
  const isInApp = useSelector(isAppAuthSelector);
  const {
    apiName
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const upgradeData = {
    app: APP,
    screen: SCREENS.PRODUCTS_PLANS,
    uniqueId: `${MERCH_CARD}-${upgradeProduct}`,
    upgradeProduct
  };

  if (isInApp) {
    return /*#__PURE__*/_jsx(CTAContainer, {
      children: /*#__PURE__*/_jsx(UIEEConnectedContactSalesButton, {
        apiName: apiName,
        upgradeData: upgradeData
      })
    });
  }

  return null;
};

export default FallbackMerchCardCTAsContainer;